<template>
  <section>
    <div :class="containerClass">
      <h3>{{ headline }}</h3>
      <p class="p1" v-for="paragraph in firstCategoryParagraphs" :key="paragraph">
        {{ paragraph }}
      </p>
      <div v-if="secondCategoryParagraphs">
        <p class="p2" v-for="paragraph in secondCategoryParagraphs" :key="paragraph">
          {{ paragraph }}
        </p>
      </div>
      <slot />
    </div>
    <img :class="imgClass" v-if="src" :src="src" :alt="alt" />
    <iframe v-if="videoSrc" :src="videoSrc"></iframe>
  </section>
</template>

<script>
export default {
  props: {
    src: String,
    videoSrc: String,
    imgClass: String,
    alt: String,
    headline: String,
    containerClass: String,
    firstCategoryParagraphs: Array,
    secondCategoryParagraphs: Array,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/fonts';
@import '~@/assets/styles/colors';
@import '~@/assets/styles/variables';
@import '~@/assets/styles/breakpoints';

section {
  width: $page-laptop-breakpoint;
  display: flex;
  justify-content: space-between;
  margin-bottom: 150px;
}

h3,
p {
  margin-bottom: 20px;
  max-width: 450px;
}

img {
  max-width: 510px;
}

.p1 {
  color: $grey;
}

.p2 {
  font-weight: bold;
}

@media (max-width: $page-laptop-breakpoint) {
  section {
    max-width: $page-table-breakpoint;
    margin-bottom: 100px;
  }

  img {
    height: 100%;
    width: 380px;
    object-fit: cover;
  }

  h3,
  p {
    margin-bottom: 10px;
    max-width: 300px;
  }
}

@media (max-width: $page-table-breakpoint) {
  section {
    max-width: $page-mobile-large-breakpoint;
    flex-direction: column;
    align-items: center;
    padding: 0 10px;
  }

  h3,
  p {
    max-width: 100%;
    text-align: center;
  }

  h3 {
    padding-bottom: 10px;
  }

  img {
    max-width: 100%;
    margin-top: 20px;
  }
}

@media (max-width: $page-mobile-large-breakpoint) {
  section {
    max-width: $page-mobile-small-breakpoint;
    margin-bottom: 75px;
  }
}
</style>
